import React, { ComponentType, lazy } from 'react';

/**
 * The type definition for the theme layouts.
 */
export type ThemeLayoutComponent =
	| ComponentType<{ children?: React.ReactNode }>
	| React.LazyExoticComponent<ComponentType<{ children?: React.ReactNode }>>;

export type themeLayoutsType = Record<string, ThemeLayoutComponent>;

/**
 * The theme layouts.
 */
const themeLayouts: themeLayoutsType = {
	layout1: lazy(() => import('./layout1/Layout1')),
	layout2: lazy(() => import('./layout2/Layout2')),
	layout3: lazy(() => import('./layout3/Layout3'))
};

export default themeLayouts;
